import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

const state = () => ({
  authorized: false,
  authChecked: false,
  selectedPhotos: [],
  recipients: [],
});

const getters = {};

const mutations = {
  setAuthorized(state, authorized) {
    state.authorized = authorized;
    state.authChecked = true;
  },
  setSelectedPhotos(state, photos) {
    state.selectedPhotos = photos;
  },
  clearSelectedPhotos(state) {
    state.selectedPhotos = [];
  },
  addRecipient(state, recipient) {
    const exists = state.recipients.some(r => r.personalId === recipient.personalId);
    if (!exists) {
      state.recipients.push(recipient);
    }
  },
  removeRecipient(state, personalId) {
    state.recipients = state.recipients.filter(r => r.personalId !== personalId);
  },
  clearRecipients(state) {
    state.recipients = [];
  },
  resetSession(state) {
    state.selectedPhotos = [];
    state.recipients = [];
  },
};

const actions = {
  async checkAccess({ commit, rootState }) {
    try {
      await axios.get(API_URL + '/photo/v2/photographer/status', {
        headers: { Authorization: `Bearer ${rootState.user.token}` },
      });
      commit('setAuthorized', true);
    } catch (e) {
      commit('setAuthorized', false);
    }
  },

  async decodeQr({ rootState }, token) {
    const { data } = await axios.post(
      API_URL + '/photo/decode-qr',
      { token },
      { headers: { Authorization: `Bearer ${rootState.user.token}` } },
    );
    return data;
  },

  async getPresignedUrls({ rootState }, { numberOfImages, personalIds }) {
    const { data } = await axios.post(
      API_URL + '/photo/v2/photographer/upload',
      { numberOfImages, personalIds },
      { headers: { Authorization: `Bearer ${rootState.user.token}` } },
    );
    return data;
  },

  async uploadWithCode({ rootState }, { numberOfImages }) {
    const { data } = await axios.post(
      API_URL + '/photo/v2/photographer/upload',
      { numberOfImages },
      { headers: { Authorization: `Bearer ${rootState.user.token}` } },
    );
    return data;
  },

  async associatePhotos({ rootState }, { photoKeys, personalIds }) {
    const { data } = await axios.post(
      API_URL + '/photo/v2/photographer/associate',
      { photoKeys, personalIds },
      { headers: { Authorization: `Bearer ${rootState.user.token}` } },
    );
    return data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
